import { render, staticRenderFns } from "./opciones-terminales.vue?vue&type=template&id=660196c6&"
import script from "./opciones-terminales.component.ts?vue&type=script&lang=ts&"
export * from "./opciones-terminales.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports